import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import reducers from '../reducers';

const persistConfig = {
  key: 'dhandha-root',
  storage,
};

const configurePersistReducer = () => {
  const persistedReducer = persistReducer(persistConfig, reducers);
  return persistedReducer;
};

export default configurePersistReducer();
